import { playerEventsForMetricAtom, playerEventsForMetricCountAtom } from '@/atoms/queries/player/playerEventData';
import { MetricKeyFallbackWrapper } from '@/components/metric/MetricKeyFallbackWrapper';
import { EventsTableBase, EventsTableWithPagination } from '@/components/tables/EventsTable';

export const PlayerVisEventsTable = () => (
  <MetricKeyFallbackWrapper fallback={<EventsTableBase isLoading />}>
    <EventsTableWithPagination eventsAtom={playerEventsForMetricAtom} dataLengthAtom={playerEventsForMetricCountAtom} />
  </MetricKeyFallbackWrapper>
);
